export function formatDate(inputDateStr) {
  const options = { year: "numeric", month: "short", day: "numeric" };
  const inputDate = new Date(inputDateStr);
  const formattedDate = inputDate.toLocaleDateString(undefined, options);

  return formattedDate;
}
